import type { IMeetingAccessRevokedNotificationData } from "@frontend-shared/types";
import { CalendarX } from "lucide-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import { NotificationCardShell } from "../NotificationCardShell";

interface IMeetingAccessRevokedCardProps {
  uuid: string;
  data: IMeetingAccessRevokedNotificationData;
  createdAt: string;
  isRead: boolean;
}

const MeetingAccessRevokedCardComponent = ({
  uuid,
  data,
  createdAt,
  isRead,
}: IMeetingAccessRevokedCardProps): React.JSX.Element => {
  const { t } = useTranslation("notifications");

  return (
    <NotificationCardShell
      uuid={uuid}
      variantTestId="meeting_access_revoked"
      createdAt={createdAt}
      isRead={isRead}
      icon={<CalendarX className="h-5 w-5 text-destructive" />}
      iconBgClassName="bg-destructive/10"
      body={t("type.meeting_access_revoked.body", {
        revokerName: data.revokerName,
        meetingTitle: data.meetingTitle,
      })}
    />
  );
};

export const MeetingAccessRevokedCard = memo(MeetingAccessRevokedCardComponent);
